/**
 * Nomes das fases para exibição.
 *
 * 'terceiro' é a disputa de 3º lugar. Ela não tem aba própria: aparece junto
 * com a final, já que as duas são geradas ao mesmo tempo e jogadas na sequência.
 */
export const PHASE_LABELS = {
  grupos: 'Fase de Grupos',
  quartas: 'Quartas de Final',
  semifinal: 'Semifinal',
  final: 'Final',
  terceiro: 'Disputa de Terceiro',
};

export function phaseLabel(phase) {
  return PHASE_LABELS[phase] || phase || '';
}
